import { Lottie } from '@taxdown/piccolo-web';
import { lottiesPaths } from 'Constants/lottiesPaths';
import { KiteLottie } from '../styles';
import * as Styled from './styles';

const Loader = (): JSX.Element => (
  <>
    <KiteLottie options={{ path: lottiesPaths.GREEN_KITE }} />
    <Styled.FlexContainer align="center" justify="center">
      <Lottie options={{ path: lottiesPaths.DASHBOARD_DATA_RETRIEVAL }} />
    </Styled.FlexContainer>
  </>
);

export default Loader;
